export default "__VITE_ASSET__C49rT76f__"